import { render, staticRenderFns } from "./cabinGroupTab.vue?vue&type=template&id=6b30dd00&"
import script from "./cabinGroupTab.vue?vue&type=script&lang=js&"
export * from "./cabinGroupTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b30dd00')) {
      api.createRecord('6b30dd00', component.options)
    } else {
      api.reload('6b30dd00', component.options)
    }
    module.hot.accept("./cabinGroupTab.vue?vue&type=template&id=6b30dd00&", function () {
      api.rerender('6b30dd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/cabinGroupTab.vue"
export default component.exports